import React from 'react';
import EditExpertExpertisePage from '../../../../pages/EditExpertExpertisePage';
import ExpertExpertisePage from '../../../../pages/ExpertExpertisePage';
import { ExpertExpertiseList } from '../../../../pages/ExpertExpertisePage/components/ExpertExpertiseList';
import ExpertUserProfilePage from '../../../../pages/ExpertUserProfilePage';
import { RoutePathsType } from '../../../../types';
import { routerPath } from '../../../routerPath';

export const expertRoutes: RoutePathsType = [
  {
    path: routerPath.expertExpertise,
    name: 'Экспертиза',
    Component: <ExpertExpertisePage />,
  },
  {
    path: routerPath.editExpertExpertiseId,
    name: 'Редактирование',
    Component: <EditExpertExpertisePage />,
  },
  {
    path: routerPath.expertUserProfile,
    name: 'Профиль',
    Component: <ExpertUserProfilePage />,
  },
  {
    path: routerPath.expertExpertiseId,
    name: 'Экспертизы',
    Component: <ExpertExpertiseList />,
  },
];
